<template>
  <Modal :value="type.length>0" :title="$t('title.w16')" :mask-closable="false" width="750" :closable="false">
    <div class="content" id="procontent">
      <ProtocolTextHk :type="type[0]" v-if="lang==='hk'"/>
      <ProtocolText :type="type[0]" v-else/>
    </div>
    <template slot="footer">
      <div class="foo">
        <Button class="no" @click="no">{{$t('btn.b8')}}</Button>
        <Button type="primary" @click="yes">{{$t('btn.b9')}}</Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import ProtocolText from "./protocolText"
import ProtocolTextHk from "./protocolText_hk"
export default {
  components: { ProtocolText ,ProtocolTextHk},
  data() {
    return {
      modal: false,
      type:[]
    }
  },
  methods: {
    no(){
      this.type=[]
      this.$emit('no')
    },
    yes() {
      this.type.shift()
      if(!this.type.length){
        this.$emit("yes");
      }
    },
    top(){
      let dom=document.getElementById('procontent')
      if(dom) dom.scrollTop=0
    }
  },
  watch:{
    type(){
      this.top()
    }
  },
  computed:{
    lang(){
      return this.$i18n.locale
    }
  }
};
</script>
<style lang="less" scoped>
.foo{
  display: flex;
  justify-content:center;
}
.no{
  border:solid 1px #7B7B7C;
  margin-right: 20px;
}
.content{
  height: 400px;
  overflow: auto;
  padding-right: 15px;
}
/deep/ .ivu-modal-body{
  padding-right: 10px;
}
</style>